import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import section9Data from './data/Section9Data' // Import FAQ data
import '../../index.css'
import ArrowUp from '../../assets/images/ArrowUp.jpg'
import ArrowDown from '../../assets/images/ArrowDown.jpg'
import LandingPageModal from '../../components/Modal'

const Section9 = () => {
  const [, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })
  const [openItemId, setOpenItemId] = useState(null)

  // Open modal with specific type
  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false)
  }

  // Close modal
  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  const { ref: Section9Ref, inView: Section9InView } = useInView({ triggerOnce: false })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  const toggleDropdown = (id) => {
    setOpenItemId(openItemId === id ? null : id)
  }

  // Pre-encode the subject for URLs (needed for Gmail link)
  const emailSubjectEncoded = encodeURIComponent('Support Request: [Brief Description of Issue]')
  const emailTo = 'support@apolop2p.com'
  const mailtoSubjectUnencoded = 'Support Request: [Brief Description of Issue]'

  const mailtoLinkDirect = `mailto:${emailTo}?subject=${mailtoSubjectUnencoded}`
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailTo}&su=${emailSubjectEncoded}`

  // Handle contact click
  const handleContactClick = () => {
    const isWindows = navigator.platform.toUpperCase().includes('WIN')

    if (isWindows) {
      window.open(gmailLink, '_blank', 'noopener,noreferrer')
    } else {
      window.location.href = mailtoLinkDirect
    }
  }

  return (
    <motion.section
      className="Section9"
      ref={Section9Ref}
      variants={fadeInUpVariant}
      initial="hidden"
      animate={Section9InView ? 'visible' : 'hidden'}
    >
      <div className="Section9-Container">
        <motion.h2
          className="Section9-Title"
          variants={fadeInUpVariant}
          transition={{ delay: 0.2 }}
        >
          FAQs
        </motion.h2>
        <motion.p
          className="Section9-Description"
          variants={fadeInUpVariant}
          transition={{ delay: 0.3 }}
        >
          Find answers to common questions about our platform and how to get started.
        </motion.p>

        <div className="Section9-List mt-16">
          {section9Data.map((faq) => (
            <div key={faq.id} className="Section9-Item">
              <div className="Section9-QuestionContainer" onClick={() => toggleDropdown(faq.id)}>
                <h4 className="Section9-Question">{faq.question}</h4>
                <img
                  src={openItemId === faq.id ? ArrowUp : ArrowDown}
                  alt="Arrow"
                  className="Section9-Arrow"
                />
              </div>
              {openItemId === faq.id && (
                <motion.p
                  className="Section9-Answer"
                  variants={fadeInUpVariant}
                  transition={{ delay: 0.2 }}
                >
                  {faq.answer}
                </motion.p>
              )}
            </div>
          ))}
        </div>

        <div className="Section9-Contact">
          <h4 className="Section9-ContactTitle">Still have questions?</h4>
          <p className="Section9-ContactDescription">
            Contact us for more information and support.
          </p>
          <button
            onClick={handleContactClick}
            className="flex items-center justify-center px-6 py-3 font-semibold text-black border-black border rounded-lg  mx-auto "
          >
            Contact
          </button>
        </div>
      </div>

      {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
    </motion.section>
  )
}

export default Section9
